module.exports = __webpack_public_path__ + "media/images/dogs/dog-life-expectancy-calculator-how-about-mixed-breed-dogs.jpg";